import React from 'react'
import contact_image from '../../../assets/images/contact/contact-image.png';

const ContactSection = () => {
  return (
    <>
      {/* Contact area start here */}
      <section className="contact-section pt-120 pb-120">
        <div className="contact-image">
          <img
            className="wow bounceInRight"
            data-wow-delay="200ms"
            data-wow-duration="1500ms"
            src={contact_image}
            alt="Image"
          />
        </div>
        <div className="container">
          <div className="outer-box">
            <div className="row g-5">
              <div className="col-lg-5 content-column">
                <div className="inner-column">
                  <div className="sec-title mb-30">
                    <h6
                      className="sub-title wow fadeInUp"
                      data-wow-delay="00ms"
                      data-wow-duration="1500ms"
                    >
                      Contact us
                    </h6>
                    <h2 className="title wow splt-txt" data-splitting>
                      let's work together
                    </h2>
                    <p
                      className="text wow fadeInUp"
                      data-wow-delay="200ms"
                      data-wow-duration="1500ms"
                    >
                      We provide reliable inspection and technical services
                      across Saudi Arabia. Our team is ready to support your
                      projects with quality, safety, and operational excellence.
                      Contact us today to discuss your requirements.
                    </p>
                  </div>
                  <ul
                    className="info wow fadeInLeft"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <li className="icon">
                      <svg
                        width={36}
                        height={32}
                        viewBox="0 0 36 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20.1094 8.61719C20.6919 8.61719 21.1641 8.14499 21.1641 7.5625C21.1641 6.98001 20.6919 6.50781 20.1094 6.50781C19.5269 6.50781 19.0547 6.98001 19.0547 7.5625C19.0547 8.14499 19.5269 8.61719 20.1094 8.61719Z"
                          fill="#1A4137"
                        />
                        <path
                          d="M24.3281 8.61719C24.9106 8.61719 25.3828 8.14499 25.3828 7.5625C25.3828 6.98001 24.9106 6.50781 24.3281 6.50781C23.7456 6.50781 23.2734 6.98001 23.2734 7.5625C23.2734 8.14499 23.7456 8.61719 24.3281 8.61719Z"
                          fill="#1A4137"
                        />
                        <path
                          d="M28.5469 8.61719C29.1294 8.61719 29.6016 8.14499 29.6016 7.5625C29.6016 6.98001 29.1294 6.50781 28.5469 6.50781C27.9644 6.50781 27.4922 6.98001 27.4922 7.5625C27.4922 8.14499 27.9644 8.61719 28.5469 8.61719Z"
                          fill="#1A4137"
                        />
                        <path
                          d="M23.7103 31.8203C25.4467 31.8203 26.8594 30.4009 26.8594 28.6562V24.4375C26.8594 23.9838 26.5692 23.581 26.139 23.4372L19.8258 21.3278C19.5167 21.2246 19.1776 21.2699 18.9065 21.4506L16.2218 23.2404C13.3405 21.8732 9.93509 18.4979 8.58059 15.6678L10.3698 12.9841C10.5504 12.7131 10.5957 12.3738 10.4925 12.0648L8.38315 5.75167C8.23936 5.32136 7.83654 5.03125 7.38281 5.03125H3.16406C1.4194 5.03125 0 6.4439 0 8.18034C0 14.0076 2.64966 19.9883 7.26961 24.589C11.8845 29.1846 17.877 31.8203 23.7103 31.8203ZM3.16406 7.14062H6.62323L8.3283 12.2436L6.50531 14.9781C6.31266 15.2671 6.27462 15.6323 6.40364 15.9548C7.10501 17.7082 8.50859 19.6802 10.3558 21.5077C12.1908 23.3231 14.1725 24.7114 15.9358 25.4167C16.2582 25.5456 16.6236 25.5076 16.9125 25.315L19.6471 23.492L24.75 25.1971V28.6562C24.75 29.2476 24.2933 29.7109 23.7103 29.7109C12.607 29.7109 2.10938 19.2475 2.10938 8.18034C2.10938 7.5973 2.57266 7.14062 3.16406 7.14062Z"
                          fill="#1A4137"
                        />
                        <path
                          d="M19.7058 19.0838C20.0998 19.247 20.5535 19.1568 20.8552 18.8552L24.765 14.9453H28.5469C32.6565 14.9453 36 11.6334 36 7.5625C36 3.49162 32.6565 0.179688 28.5469 0.179688H20.1094C16.0385 0.179688 12.7266 3.49162 12.7266 7.5625C12.7266 11.2754 15.4816 14.3569 19.0547 14.8702V18.1094C19.0547 18.536 19.3117 18.9205 19.7058 19.0838ZM14.8359 7.5625C14.8359 4.65473 17.2016 2.28906 20.1094 2.28906H28.5469C31.4934 2.28906 33.8906 4.65473 33.8906 7.5625C33.8906 10.4703 31.4934 12.8359 28.5469 12.8359H24.3281C24.0484 12.8359 23.7801 12.947 23.5824 13.1448L21.1641 15.5632V13.8906C21.1641 13.3082 20.6918 12.8359 20.1094 12.8359C17.2016 12.8359 14.8359 10.4703 14.8359 7.5625Z"
                          fill="#1A4137"
                        />
                      </svg>
                    </li>
                    <li>
                      <p className="sub-title">Call For Inquiry</p>
                      <h4 className="title">+966 53 589 7085</h4>
                    </li>
                  </ul>
                  <ul
                    className="info mt-30 wow fadeInLeft"
                    data-wow-delay="200ms"
                    data-wow-duration="1500ms"
                  >
                    <li className="icon">
                      <svg
                        width={32}
                        height={24}
                        viewBox="0 0 32 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M29 0C30.625 0 32 1.375 32 3V21C32 22.6875 30.625 24 29 24H3C1.3125 24 0 22.6875 0 21V3C0 1.375 1.3125 0 3 0H29ZM29 3H3V5.5625C4.375 6.75 6.625 8.5 11.375 12.25C12.4375 13.0625 14.5 15.0625 16 15C17.4375 15.0625 19.5 13.0625 20.5625 12.25C25.3125 8.5 27.5625 6.75 29 5.5625V3ZM3 21H29V9.4375C27.5625 10.5625 25.5 12.1875 22.4375 14.625C21 15.6875 18.625 18.0625 16 18C13.3125 18.0625 10.875 15.6875 9.5 14.625C6.4375 12.1875 4.375 10.5625 3 9.4375V21Z"
                          fill="#1A4137"
                        />
                      </svg>
                    </li>
                    <li>
                      <p className="sub-title">Send Us Email</p>
                      <h4 className="title">info@paic-sa.com</h4>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="contact-block">
                  <div className="head">
                    <h3 className="title">
                      Need Inspection Support for Your Project?
                    </h3>
                    <p className="sub-title">
                      Let’s collaborate to ensure quality, safety, and reliable
                      inspection solutions.
                    </p>
                  </div>
                  <form action="#0">
                    <div className="row g-4">
                      <div className="col-sm-6">
                        <div className="input">
                          <svg
                            className="icon"
                            width={14}
                            height={16}
                            viewBox="0 0 14 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.78125 9.5C12.0938 9.5 14 11.4062 14 13.7188V14.5C14 15.3438 13.3125 16 12.5 16H1.5C0.65625 16 0 15.3438 0 14.5V13.7188C0 11.4062 1.875 9.5 4.1875 9.5C5.09375 9.5 5.5 10 7 10C8.46875 10 8.875 9.5 9.78125 9.5ZM12.5 14.5V13.7188C12.5 12.2188 11.2812 11 9.78125 11C9.3125 11 8.59375 11.5 7 11.5C5.375 11.5 4.65625 11 4.1875 11C2.6875 11 1.5 12.2188 1.5 13.7188V14.5H12.5ZM7 9C4.5 9 2.5 7 2.5 4.5C2.5 2.03125 4.5 0 7 0C9.46875 0 11.5 2.03125 11.5 4.5C11.5 7 9.46875 9 7 9ZM7 1.5C5.34375 1.5 4 2.875 4 4.5C4 6.15625 5.34375 7.5 7 7.5C8.625 7.5 10 6.15625 10 4.5C10 2.875 8.625 1.5 7 1.5Z"
                              fill="#696969"
                            />
                          </svg>
                          <input type="text" placeholder="Your Name" />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="input">
                          <svg
                            className="icon"
                            width={16}
                            height={12}
                            viewBox="0 0 16 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.5 0C15.3125 0 16 0.6875 16 1.5V10.5C16 11.3438 15.3125 12 14.5 12H1.5C0.65625 12 0 11.3438 0 10.5V1.5C0 0.6875 0.65625 0 1.5 0H14.5ZM14.5 1.5H1.5V2.78125C2.1875 3.375 3.3125 4.25 5.6875 6.125C6.21875 6.53125 7.25 7.53125 8 7.5C8.71875 7.53125 9.75 6.53125 10.2812 6.125C12.6562 4.25 13.7812 3.375 14.5 2.78125V1.5ZM1.5 10.5H14.5V4.71875C13.7812 5.28125 12.75 6.09375 11.2188 7.3125C10.5 7.84375 9.3125 9.03125 8 9C6.65625 9.03125 5.4375 7.84375 4.75 7.3125C3.21875 6.09375 2.1875 5.28125 1.5 4.71875V10.5Z"
                              fill="#696969"
                            />
                          </svg>
                          <input type="email" placeholder="Email Address" />
                        </div>
                      </div>
                    </div>
                    <select className="mt-4" name="#" id="subject">
                      <option value={0}>Choose Our Service</option>
                      <option value={1}>Geotechnical Investigation</option>
                      <option value={2}>Calibration Services</option>
                      <option value={3}>
                        Material Testing Services – Asphalt
                      </option>
                      <option value={4}>
                        Material Testing Services – Concrete
                      </option>
                      <option value={6}>
                        Material Testing Services – Steel
                      </option>
                      <option value={7}>
                        Non-Destructive Testing (NDT) Services
                      </option>
                      <option value={8}>
                        Scaffolding Services
                      </option>
                      <option value={9}>
                        Turnaround and Shutdown Inspection Support
                      </option>
                      <option value={10}>
                        Third-Party Inspection Services
                      </option>
                      <option value={11}>
                        Inspection & Training Division
                      </option>
                    </select>
                    <textarea
                      className="mt-4"
                      name="masage"
                      id="masage"
                      placeholder="Write a Message"
                      defaultValue={""}
                    />
                    <button className="btn-two-rounded mt-30">
                      Send Message Us{" "}
                      <i className="fa-regular fa-angle-right" />
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Contact area end here */}
    </>
  );
}

export default ContactSection